/** Quebra descrições com `<br>` em linhas renderizáveis. */
export function parseSurveyDescription(description?: string) {
  if (!description) return null;
  const lines = description.split(/<br\s*\/?>/i);
  return lines.map((line, i) => (
    <span key={i}>
      {line}
      {i < lines.length - 1 ? <br /> : null}
    </span>
  ));
}
